import MuiPaper, { PaperProps as MuiPaperProps } from '@mui/material/Paper';
import React from 'react';

export interface PaperProps extends MuiPaperProps {}

export const Paper = (props: PaperProps) => {
  return <MuiPaper {...props} />;
};
